export default __webpack_public_path__ + "e595b0a49442b6ac4ea03fe41927f9b6.jpg";